export var initConfig = {
  includeGclid: true,
  includeReferrer: true,
  includeUtm: true,
  unsetParamsReferrerOnNewSession: true,
  saveEvents: true,
  // Disabled because it causes link callbacks to be executed after some time
  // batchEvents: true,
  logLevel: process.env.NODE_ENV === 'development' ? 'INFO' : 'DISABLE'
};